import React from "react";
import heroImage from "./Assets/newimage.png";
import microsoftIcon from "../../Asset/microsoft icon.svg";
import { ReactSVG } from "react-svg";

const HeroSection = () => {
  return (
    <div className="relative overflow-hidden rounded-2xl mt-6 md:mt-0 bg-[#D8EFFD] border border-[#3AB1F626]">
      <div
        className="absolute pointer-events-none rounded-full"
        style={{
          width: "min(650px, 75vw)",
          height: "min(650px, 75vw)",
          left: "-15%",
          bottom: "-25%",
          background: "#3AB1F6",
          opacity: 0.45,
          filter: "blur(140px)",
          WebkitFilter: "blur(140px)",
        }}
      />
      <div
        className="absolute pointer-events-none rounded-full"
        style={{
          width: "min(650px, 75vw)",
          height: "min(650px, 75vw)",
          right: "-15%",
          top: "-25%",
          background: "#3AB1F6",
          opacity: 0.45,
          filter: "blur(140px)",
          WebkitFilter: "blur(140px)",
        }}
      />

      <div className="relative z-10 flex md:flex-row flex-col items-center md:gap-6 gap-10 md:pt-48 pt-40 md:pb-40 pb-24 lg:px-16 md:px-8 px-4">
        <div className="flex-1 flex flex-col md:items-start items-center gap-5">
          <h1 className="font-jakarta font-extrabold text-[#0F1B2D] text-center md:text-left text-[2.5rem] sm:text-[3rem] md:text-[3.4rem] lg:text-[4rem] leading-[1.1] tracking-[-0.025em]">
            The Fastest Way to{" "}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]">
              Write on Windows.
            </span>
          </h1>

          <p className="font-inter font-normal text-[#33425A] text-center md:text-left text-[1rem] sm:text-[1.125rem] md:text-[1.25rem] lg:text-[1.3125rem] leading-[1.5] max-w-[641px]">
            Zero Typing turns your voice into clean, ready-to-use text across
            emails, documents, messages, and work apps. No fixing.
          </p>

          <div className="flex sm:flex-row flex-col items-center gap-3 mt-2">
            <a
              href="https://zerotyping.ai/ztaupdate/ZeroTypingAI.msi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                style={{
                  background: "linear-gradient(90deg, #3AB1F6 0%, #407BFF 100%)",
                }}
                className="hover:opacity-90 transition-opacity duration-300 text-white rounded-full flex items-center gap-2 px-6 py-3 font-inter font-semibold text-base shadow-md"
              >
                <ReactSVG
                  src={microsoftIcon}
                  beforeInjection={(svg) => {
                    svg.setAttribute("class", "w-5 h-5");
                  }}
                />
                Download for Windows
              </button>
            </a>

            <button className="bg-white border border-[#0000001A] hover:bg-gray-50 transition rounded-full flex items-center gap-2 px-6 py-3 font-inter font-semibold text-base text-[#0F1B2D]">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
              Watch 45-sec demo
            </button>
          </div>
        </div>

        <div className="flex-1 w-full flex justify-center">
          <img
            src={heroImage}
            alt="Zero Typing on Windows"
            className="block w-full max-w-[640px] md:max-w-[720px] lg:max-w-[760px] h-auto self-center"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
